// Copyright 2019 Sorama B.V.

import { IWorkflowPropertyParser } from "libraries/WorkflowFramework/Interfaces/IWorkflowPropertyParser";

export class NumberParser implements IWorkflowPropertyParser<number> {
    toWorkflowProperty(object: number): string {
        if (isNaN(object)) {
            return undefined;
        }

        if (object === undefined || object === null) {
            return undefined;
        }

        return object.toString();
    }

    fromWorkflowProperty(str: unknown): number {
        const number = Number(str);

        if (isNaN(number)) {
            return undefined;
        }

        return number;
    }
}
